import PropTypes from "prop-types";
import ProductTilePlaceholder from "../ProductTilePlaceholder";
import LazyLoadObserver from "../../../containers/common/LazyLoadObserver";
import { isFullyLoaded } from "../../../../state/modules/savedItems/selectors/itemStateSelectors";
import SavedItemsProductTileList from "../../../containers/common/SavedItemsProductTileList";
import isLastBestPriceEnabled from "../../common/SavedItemsProductTiles/isLastBestPriceEnabled";

const SavedItemsProductTiles = ({
  savedItems,
  ProductTile,
  showDiscountLabel,
  isAuthenticated
}) => {
  const showExtendedPricing = isLastBestPriceEnabled();

  return (
    <>
      <SavedItemsProductTileList>
        {savedItems.map((item, index) => (
          <li key={item.id}>
            {isFullyLoaded(item) ? (
              <ProductTile
                {...{
                  ...item,
                  index,
                  showDiscountLabel,
                  showExtendedPricing,
                  isAuthenticated
                }}
              />
            ) : (
              <ProductTilePlaceholder itemState={item.itemState} />
            )}
          </li>
        ))}
      </SavedItemsProductTileList>
      <LazyLoadObserver />
    </>
  );
};

SavedItemsProductTiles.propTypes = {
  ProductTile: PropTypes.elementType.isRequired,
  savedItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      variants: PropTypes.array
    }).isRequired
  ),
  showDiscountLabel: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired
};

export default SavedItemsProductTiles;
